<!-- https://xd.adobe.com/view/cf3b6017-08c1-4af1-844b-37c751355cf2-9a68/screen/12500773-4838-4be6-a263-8bc8fe53e6d5/ 
-->
<template>
  <div id="contract-main-viewer" class="clearfix noto-sans darkblue px2 mb4">
    <div class="col-12">
          <div class="clearfix max-width-3 mx-auto mt3">
            <div class="col-12 mt2 px0 flex flex-column justify-center items-center">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="71.243" height="71.243" viewBox="0 0 71.243 71.243">
                      <path id="Icon_awesome-check-circle" data-name="Icon awesome-check-circle" d="M71.805,36.184A35.621,35.621,0,1,1,36.184.563,35.621,35.621,0,0,1,71.805,36.184ZM32.064,55.045,58.492,28.616a2.3,2.3,0,0,0,0-3.25l-3.25-3.25a2.3,2.3,0,0,0-3.25,0L30.439,43.67,20.376,33.607a2.3,2.3,0,0,0-3.25,0l-3.25,3.25a2.3,2.3,0,0,0,0,3.25L28.813,55.045a2.3,2.3,0,0,0,3.25,0Z" transform="translate(-0.563 -0.563)" fill="#63d768"/>
                    </svg>
                </span>
                <p class="h2 semi-bold line-height-2 my3 center ">Success! Entreprisekontrakten er nu underskrevet!</p>
                <p class="h5 regular line-height-2 my3 center mediumgrey">Kunden er blevet underrettet om den underskrevne aftale. Vi anbefaler, at du først starter op på projektet, når du har modtaget en skriftlig bekræftelse på, at betalingen er overført til deponeringskontoen hos PayProff.</p>
            </div>
            <div class="flex flex-column p0 m0 ">
            <span class="regular font12 p0">
              For at se status og administrere dine projekter, besøg:
            </span>
            <button class="p2 px3 my1 action-button rounded" @click="gotodashboard()">
              <span>Projektadministration</span>
            </button>
            </div>
            <div class="py3"></div>
          </div>
    </div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    <ErrorHandler ref="errorMsg"></ErrorHandler>
  </div>
</template>
<script>
export default {
  name: 'contract-main_tak',
  data () {
    return {
      loading: false,
      projectid: '',
      contactid: '',
      parentID: '',
      contracttype: '',
      projecttitle: ''
    }
  },
  created () {
    this.projectid = this.$route.query.projectId
    this.contactid = this.$route.query.contactID
    this.parentID = this.$route.query.parentID
    this.contracttype = this.$route.query.contracttype
    this.projecttitle = this.$route.query.projecttitle
  },
  methods: {
    gotodashboard () {
      this.$router.push('/customer-projects/project-dashboard?projectId=' + this.projectid + '&contactID=' + this.contactid + '&parentID=' + this.parentID + '&contracttype=' + this.contracttype + '&projecttitle=' + this.projecttitle)
    }
  },
  watch: {
  }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// contract-main-tak.vue?6fcd0afa